import {
  ApiFactory,
  configApiRef,
  createApiFactory,
  discoveryApiRef,
  FetchApi,
  fetchApiRef,
  identityApiRef,
} from '@backstage/core-plugin-api';
import { createFetchApi, FetchMiddlewares } from '@backstage/core-app-api';
import { LOCAL_STORAGE_PENDING_RELOAD_KEY } from './constants';

export const createVersionCheckFetchApiFactory = (): ApiFactory<
  FetchApi,
  FetchApi,
  {}
> =>
  createApiFactory({
    api: fetchApiRef,
    deps: {
      configApi: configApiRef,
      identityApi: identityApiRef,
      discoveryApi: discoveryApiRef,
    },
    factory: ({ configApi, identityApi, discoveryApi }) => {
      return createFetchApi({
        baseImplementation: async (...args) => {
          // check if a new server revision has deployed and is out-of-sync
          // with the single-page front-end
          const response = await global.fetch(...args);
          const revision = response.headers.get(
            'X-AppFolio-Backstage-Revision',
          );
          if (
            revision &&
            revision !== configApi.getString('appfolio.app.revision')
          ) {
            window.localStorage.setItem(
              LOCAL_STORAGE_PENDING_RELOAD_KEY,
              'true',
            );
          }
          return response;
        },
        middleware: [
          FetchMiddlewares.resolvePluginProtocol({
            discoveryApi,
          }),
          FetchMiddlewares.injectIdentityAuth({
            identityApi,
            config: configApi,
          }),
        ],
      });
    },
  });
